module.exports = {"label":"Auth-Info","generationHint":"Icon anklicken zum Generieren"}